import React from "react";
import counterStore, {
  add,
  minus,
  reset,
  addAfter1s,
  minusAfter1s
} from "./store";

export default function Counter() {
  const { count } = counterStore.useState("count");
  return (
    <div>
      <div>{count}</div>
      <button onClick={add}>+1</button>
      <button onClick={minus}>-1</button>
      <button onClick={addAfter1s}>+5 after 1s</button>
      <button onClick={minusAfter1s}>-5 after 1s</button>
      <br />
      <button onClick={reset}>Reset</button>
    </div>
  );
}
